import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { useInAudit } from 'src/context/AuditContext'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { DashboardDimensionFilterDropdown } from './DashboardDimensionFilterDropdowns/DashboardDimensionFilterDropdown'

export const DashboardFrameworkFilterDropdown = ({
  isNested = false,
  dashboardContext,
  dashboardName,
}: {
  isNested?: boolean
  dashboardContext?: DASHBOARD_CONTEXT
  dashboardName?: string
}): JSX.Element | null => {
  const { auditId } = useInAudit()

  // Hidden inside an audit, as before: the audit already fixes its frameworks, and
  // useOEDashboardSections separately restricts sections to that audit's framework list.
  if (auditId) {
    return null
  }
  if (dashboardContext === undefined || dashboardName === undefined) {
    return null
  }

  return (
    <DashboardDimensionFilterDropdown
      isNested={isNested}
      filterParam={FilterParam.DASHBOARD_FRAMEWORK}
      filterName={FilterName.DASHBOARD_FRAMEWORK}
      dashboardContext={dashboardContext}
      dashboardName={dashboardName}
      dimension="frameworks"
    />
  )
}
